
  import { Vue, Component, Prop } from "vue-property-decorator";
  import moment from "moment";

  import Card from "@/components/card/Card.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import TableIcon from "@/components/table/table-icon.vue";
  import CardPagination from "@/components/card/CardPagination.vue";
  import Processing from "@/components/common/Processing.vue";
  import DocumentProvider from "@/components/documents/DocumentProvider.vue";
  import splitFileNameExt from "@/utils/splitFileNameExt";
  import TableAvatar from "@/components/table/TableAvatar.vue";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import PopUpContainer from "@/components/common/PopUpContainer.vue";
  import EyeIcon from "@/components/icons/EyeIcon.vue";
  import DownloadIcon from "@/components/icons/DownloadIcon.vue";
  import LinkIcon from "@/components/icons/LinkIcon.vue";
  import TrashIcon from "@/components/icons/TrashIcon.vue";
  import DocumentUserInformation from "@/components/documents/DocumentUserInformation.vue";
  import ButtonDropdown from "@/components/common/ButtonDropdown.vue";
  import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
  import DocumentExtensionIcon from "@/components/documents/DocumentExtensionIcon.vue";


  import { Document } from "@/interface";
  import { User } from "@/generated/graphql";
  import { selfVisible } from "@/data/badgesText";
  import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModal.vue";

  @Component({
    components: {
      ConfirmRemovingDocumentModal,
      Card,
      CardBodyItem,
      TableIcon,
      CardPagination,
      Processing,
      DocumentProvider,
      TableAvatar,
      CardInfoChip,
      UiButton,
      PopUpContainer,
      EyeIcon,
      DownloadIcon,
      LinkIcon,
      TrashIcon,
      DocumentUserInformation,
      ColorIconContainer,
      ButtonDropdown,
      DocumentExtensionIcon,
    },
  })
  export default class DocumentItem extends Vue {
    @Prop({ type: Object, required: true }) readonly document!: Document;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
    @Prop({ type: Boolean, default: false }) readonly extraInfoHidden!: boolean;

    actionsPopUpShown: boolean = false;
    selfVisible: string = selfVisible;

    get isUploadedByCurrentUser(): boolean {
      return this.currentUser.id === this.document.uploaded_by;
    }

    get isVisibleOnlyToCurrentUser(): boolean {
      return this.document.document_projects.length === 0;
    }

    get createdAt(): string {
      return moment(this.document.created_at).format("DD MMM YYYY");
    }

    get documentSize(): string {
      const size = (this.document.size / 1024)
        .toFixed(1)
        .replace('.0', '');

      return `${size} kB`;
    }

    get documentFormat(): string {
      const { ext } = splitFileNameExt(this.document.filename);
      return ext;
    }

    get uploadedByUser(): User {
      return this.document.user;
    }

    showActionsPopUp() {
      this.actionsPopUpShown = true;
    }

    hideActionsPopUp(callback: Function) {
      this.actionsPopUpShown = false;
      callback();
    }

    removeDocument(remove: Function) {
      if (this.frozen) {
        return;
      }
      remove();
    }
  }
